/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PickupPointDto } from '../../models/pickup-point-dto';

export interface MgmtOrderPickupControllerFindPickupPoint$Params {
  id: number;
}

export function mgmtOrderPickupControllerFindPickupPoint(http: HttpClient, rootUrl: string, params: MgmtOrderPickupControllerFindPickupPoint$Params, context?: HttpContext): Observable<StrictHttpResponse<PickupPointDto>> {
  const rb = new RequestBuilder(rootUrl, mgmtOrderPickupControllerFindPickupPoint.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PickupPointDto>;
    })
  );
}

mgmtOrderPickupControllerFindPickupPoint.PATH = '/api/mgmt-orders/{id}/pickup-point';
